import { render, staticRenderFns } from "./CreateKlaimPp.vue?vue&type=template&id=033b9ed1&scoped=true&"
import script from "./CreateKlaimPp.vue?vue&type=script&lang=js&"
export * from "./CreateKlaimPp.vue?vue&type=script&lang=js&"
import style0 from "./CreateKlaimPp.vue?vue&type=style&index=0&id=033b9ed1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b9ed1",
  null
  
)

export default component.exports